/**
 * The document panel type: a Document report — designed, paginated paper (letter, A4 and the rest,
 * portrait or landscape, page by page), written by the transform in paper markup and printed by the
 * render service to a PDF. See docs/plans/active/cirra/2026-10-07-analytics-report-formats.
 */

const document = {
  /* `reportFormat`: one of the shapes a report page's one panel may take (ADR 001). Not `advanced`:
     the body is paper markup compiled to an AST when the panel cooks, so display code may never
     return this type — the same rule as html. */
  names: [
    {
      id: 'document',
      label: 'Document',
      formatLabel: 'Document',
      phrase: 'a document',
      guide: 'document.md',
      companionGuides: ['report-ai-snippets.md'],
      reportFormat: true,
      advanced: false,
      toolSummary: 'a designed, paginated document — letter/A4 pages, portrait or landscape — that the transform writes in paper markup and the platform prints to PDF',
      promptSummary: 'a designed, paginated document the transform writes in paper markup (real HTML and CSS: tables, images, colours, fonts, embedded charts) and the platform prints to PDF — for a report that must look a specific way on paper, or that reproduces an existing one'
    }
  ],
  block: 'document',
  /* One column of the first row holds the whole document body { html, css, panels }, the same
     one-row shape as the report and html types. */
  fields: {
    key: { kind: 'string', required: true, clearable: true, hint: 'the whole document lives in one column of the first row, as { html, css, panels }', label: 'Document column' }
  },
  editorHint: "One row is one document: the first row's value at this column is { html, css, panels } — paper markup, its stylesheet and its charts — written by the transform. A column named document is picked up automatically.",
  stateSummary: ({ block, type }) => (type === 'document' ? `document: body key ${block.key || 'document'}` : ''),
  toolSchema: {
    type: ['object', 'null'],
    additionalProperties: false,
    required: ['key'],
    description: 'Document mapping (displayType "document"): the FIRST data row\'s value at this key is the ENTIRE document body — { html, css, panels } — that the transform writes from the data. Omit the WHOLE block (or send null) to fall back to a column named "document". MANDATORY before authoring: knowledge_read immutable/analytics/panel-types/document.md, then immutable/analytics/paper-markup.md — markup outside paper markup fails the cook.',
    properties: {
      key: { type: 'string', description: 'Column holding the document body { html, css, panels }.' }
    }
  }
};

export default document;
